import { Variation } from './ResolutionSchemaDefinition.js';
import { LookupId, PropertyPath } from '../engine.js';
import { ObjectHashSet } from './ObjectHashSet.js';
import { engineUtils } from '../services/EngineUtils.js';
type Variant = LookupId | LookupId[];

export class VariationOrderGenerator {
  constructor(
    private explicitVariants: Variation
  ) {
  }

  * getVariation(): Generator<Variant> {
    const explicitVariants = new ObjectHashSet();
    const lookupIds = this.getDistinctLookupIds();
    for (const variant of this.explicitVariants) {
      explicitVariants.add(variant);
      yield variant;
    }

    for (let n = 1; n <= lookupIds.length; n++) {
      if (n === 1) {
        for (const lookupId of lookupIds) {
          if (!explicitVariants.has(lookupId)) {
            yield lookupId;
          }
        }
      } else {
        const first = [];
        for (let i = 0; i < lookupIds.length; i++) {
          first.push(i);
        }
        const fns = [];
        const indexes = [];
        for (let i = 0; i < n-1; i++) {
          fns.push((prev) => {
            indexes[i] = prev;
            const result = []
            for (let j = prev + 1; j < lookupIds.length; j++) {
              result.push(j);
            }
            return result;
          })
        }
        const variations = engineUtils.cartesian(first, fns, (lastIndex) => {
          indexes[n - 1] = lastIndex;
          const variation = [];
          for (let i = 0; i < indexes.length; i++) {
            variation[i] = lookupIds[indexes[i]];
          }
          return variation;
        })
        for (let variation of variations) {
          if (!explicitVariants.has(variation)) {
            yield variation;
          }
        }
      }
    }

  }

  getDistinctLookupIds(): LookupId[] {
    const lookupIds = new Set<LookupId>();
    for (const variant of this.explicitVariants) {
      if (Array.isArray(variant)) {
        variant.forEach(id => lookupIds.add(id));
      } else {
        lookupIds.add(variant);
      }
    }
    return Array.from(lookupIds);
  }
}
